import React, { useEffect, useState } from "react";
import axios from "axios";
import {
 Card,
 CardContent,
 CardActions,
 Checkbox,
 Button,
 Typography,
 FormControlLabel,
} from "@mui/material";

const CODVisibilityCard = () => {
 const [showCOD, setShowCOD] = useState(null);
 const [isEditing, setIsEditing] = useState(false);

 useEffect(() => {
  // Fetch the current COD visibility setting when the component mounts
  axios
   .get("https://app-api.carexpert.org.in/api/admin-settings/cod-visibility")
   .then((response) => {
    if (response.data) {
     setShowCOD(response.data.showCOD);
    }
   })
   .catch((error) => {
    console.error("Error fetching COD visibility:", error);
   });
 }, []);

 const handleUpdateCODVisibility = () => {
  axios
   .post("https://app-api.carexpert.org.in/api/admin-settings/cod-visibility", {
    showCOD,
   })
   .then((response) => {
    setShowCOD(response.data.showCOD);
    setIsEditing(false);
    alert("COD visibility updated successfully");
   })
   .catch((error) => {
    console.error("Error updating COD visibility:", error);
    alert("Failed to update COD visibility");
   });
 };

 return (
  <Card
   sx={{
    maxWidth: 400,
    margin: "20px auto",
    padding: "20px",
    borderRadius: "8px",
    boxShadow: 3,
   }}
  >
   <CardContent>
    <Typography variant="h5" sx={{ marginBottom: "10px", fontWeight: 500 }}>
     COD Visibility
    </Typography>
    {isEditing ? (
     <FormControlLabel
      control={
       <Checkbox
        checked={showCOD}
        onChange={(e) => setShowCOD(e.target.checked)}
        color="primary"
       />
      }
      label="Show COD"
      sx={{ fontSize: "1rem", marginLeft: "8px" }}
     />
    ) : (
     <Typography variant="body1" sx={{ marginBottom: "20px" }}>
      Current COD Visibility: {showCOD ? "Enabled" : "Disabled"}
     </Typography>
    )}
   </CardContent>
   <CardActions>
    {isEditing ? (
     <>
      <Button
       variant="contained"
       color="primary"
       onClick={handleUpdateCODVisibility}
      >
       Save
      </Button>
      <Button
       variant="outlined"
       color="secondary"
       onClick={() => setIsEditing(false)}
       sx={{ marginLeft: "10px" }}
      >
       Cancel
      </Button>
     </>
    ) : (
     <Button
      variant="outlined"
      color="primary"
      onClick={() => setIsEditing(true)}
     >
      Edit
     </Button>
    )}
   </CardActions>
  </Card>
 );
};

export default CODVisibilityCard;
